import ActivationForm from './ActivationForm'

export default ActivationForm
